import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { BackboneView } from 'app/react/components/_index';
import * as stateHelpers from 'app/react/state/helpers';
import ContentWrapper from 'app/react/components/layout/content/ContentWrapper';
import ContentHeader, { TABS } from '../ContentHeader';
import ProfileUpdateContent from 'app/backbone/views/event/settings/accreditation/profiles/views/ProfileUpdateContent.view';

const { Content } = ContentWrapper;

const ProfilesView = ({
    event,
    profiles,
    profile,
    days,
    zones,
    isLoading,
    eventId
}) => (
    <ContentWrapper>
        <ContentHeader activeTab={TABS.PROFILES.ID} eventId={eventId} />
        <Content isLoading={isLoading} >
            <BackboneView
                viewClass={ProfileUpdateContent}
                event={event}
                profiles={profiles}
                profile={profile}
                days={days}
                zones={zones}
            />
        </Content>
    </ContentWrapper>
);

ProfilesView.propTypes = {
    event: PropTypes.object.isRequired,
    profiles: PropTypes.object.isRequired,
    profile: PropTypes.object.isRequired,
    days: PropTypes.object.isRequired,
    zones: PropTypes.object.isRequired,
    // State
    isLoading: PropTypes.bool.isRequired,
    eventId: PropTypes.number.isRequired
};

const mapStateToProps = (state) => ({
    isLoading: stateHelpers.isLoading(state),
    eventId: stateHelpers.events.getCurrentId(state)
});

export default connect(mapStateToProps)(ProfilesView);
